import React, { useContext, useEffect } from 'react';
import progressContext from '../../context/loading/progresscontext';
import footerMenuContext from '../../context/footermenu/footermenucontext';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

function PrivacyPolicy() {
    const { setProgress } = useContext(progressContext);
    const { disclaimer } = useContext(footerMenuContext);

    useEffect(() => {
        if (setProgress) {
            setProgress(70);
            setTimeout(() => {
                setProgress(100);
            }, 100);
        }
    }, [setProgress]);

    return (
        <main>
            <Breadcrumb
                pageName="Privacy Policy"
                bgImage="/img/uplaods/rad.jpg"
                path={[
                    { label: 'Home', href: '/' },
                    { label: 'Privacy Policy' }
                ]}
            />
            <section className="band">
                <div className="wrap" style={{ maxWidth: '800px' }}>
                    <div className="policy-content" style={{ fontSize: '16px', lineHeight: '1.7', color: 'var(--muted)' }}>
                        {disclaimer && disclaimer.privacy_policy ? (
                            <div dangerouslySetInnerHTML={{ __html: disclaimer.privacy_policy }}></div>
                        ) : (
                            <div>
                                <p>Lakshmi Maternity &amp; Surgical Centre is committed to safeguarding the privacy and confidentiality of our patients' personal and medical data. Any information collected through this website or during your visits is used solely for the provision of medical care and administrative services.</p>
                                <p style={{ marginTop: '16px' }}>We do not sell, distribute, or share confidential medical information with third parties without your explicit prior consent, except as required by law.</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </main>
    );
}

export default PrivacyPolicy;